import { IAction, IState, defaultContextValues } from './UseNewCampaignContext';

export type ActionTypes =
  | 'CLEAR_ERROR'
  | 'CREATE_CAMPAIGN_FAILED'
  | 'RESET_WIZARD'
  | 'SET_NAME_VALUE'
  | 'SET_STATE_VALUE'
  | 'SET_START_DATE_VALUE'
  | 'SET_END_DATE_VALUE'
  | 'SET_SELECTED_FEATURE_VALUE'
  | 'SET_SELECTED_OBJECTIVE_VALUE'
  | 'UPDATE_STEP_VALID'
  | 'UPDATE_VALID_STEPS'
  | 'UPDATE_CAMPAIGN';

export function NewCampaignReducer(state: IState, action: IAction) {
  const { payload } = action;
  let newState: IState = null;

  switch (action.type) {
    case 'CLEAR_ERROR':
      newState = {
        ...state,
        error: false,
      };
      break;
    case 'CREATE_CAMPAIGN_FAILED':
      newState = {
        ...state,
        success: payload.success,
        createdCombinedCampaign: payload.createdCombinedCampaign,
        error: payload.error,
        errorMessage: payload.errorMessage,
      };
      break;
    case 'RESET_WIZARD':
      newState = { ...defaultContextValues };
      break;
    case 'SET_NAME_VALUE':
      if (state.combinedCampaign.objective === 'Recover Abandoned Sales') {
        newState = {
          ...state,
          combinedCampaign: {
            ...state.combinedCampaign,
            offsiteCampaign: {
              ...state.combinedCampaign.offsiteCampaign,
              name: payload.name,
            },
          },
        };
      } else {
        newState = {
          ...state,
          combinedCampaign: {
            ...state.combinedCampaign,
            campaign: {
              ...state.combinedCampaign.campaign,
              name: payload.name,
            },
          },
        };
      }
      break;
    case 'SET_STATE_VALUE':
      if (state.combinedCampaign.objective === 'Recover Abandoned Sales') {
        newState = {
          ...state,
          combinedCampaign: {
            ...state.combinedCampaign,
            offsiteCampaign: {
              ...state.combinedCampaign.offsiteCampaign,
              state: payload.state,
            },
          },
        };
      } else {
        newState = {
          ...state,
          combinedCampaign: {
            ...state.combinedCampaign,
            campaign: {
              ...state.combinedCampaign.campaign,
              state: payload.state,
            },
          },
        };
      }
      break;
    case 'SET_START_DATE_VALUE':
      if (state.combinedCampaign.objective === 'Recover Abandoned Sales') {
        const offsiteStartTime =
          payload.startTime !== undefined && payload.startTime !== null ? payload.startTime.valueOf() : undefined;

        newState = {
          ...state,
          combinedCampaign: {
            ...state.combinedCampaign,
            offsiteCampaign: {
              ...state.combinedCampaign.offsiteCampaign,
              startTime: offsiteStartTime,
            },
          },
        };
      } else {
        newState = {
          ...state,
          combinedCampaign: {
            ...state.combinedCampaign,
            campaign: {
              ...state.combinedCampaign.campaign,
              startTime: payload.startTime,
            },
          },
        };
      }
      break;
    case 'SET_END_DATE_VALUE':
      if (state.combinedCampaign.objective === 'Recover Abandoned Sales') {
        const offsiteEndTime =
          payload.endTime !== undefined && payload.endTime !== null ? payload.endTime.valueOf() : undefined;
        newState = {
          ...state,
          combinedCampaign: {
            ...state.combinedCampaign,
            offsiteCampaign: {
              ...state.combinedCampaign.offsiteCampaign,
              endTime: offsiteEndTime,
            },
          },
        };
      } else {
        newState = {
          ...state,
          combinedCampaign: {
            ...state.combinedCampaign,
            campaign: {
              ...state.combinedCampaign.campaign,
              endTime: payload.endTime,
            },
          },
        };
      }
      break;
    case 'SET_SELECTED_FEATURE_VALUE':
      if (state.combinedCampaign.objective === 'Recover Abandoned Sales') {
        newState = {
          ...state,
          combinedCampaign: {
            ...state.combinedCampaign,
            offsiteCampaign: {
              ...state.combinedCampaign.offsiteCampaign,
              type: 'cartAbandonment',
            },
            type: payload.selectedFeature,
          },
        };
      } else {
        newState = {
          ...state,
          combinedCampaign: {
            ...state.combinedCampaign,
            campaign: {
              ...state.combinedCampaign.campaign,
              type: payload.selectedFeature,
            },
            type: payload.selectedFeature,
          },
        };
      }
      break;
    case 'SET_SELECTED_OBJECTIVE_VALUE':
      if (payload.selectedObjective === 'Recover Abandoned Sales') {
        newState = {
          ...state,
          combinedCampaign: {
            offsiteCampaign: {
              ...state.combinedCampaign.offsiteCampaign,
            },
            objective: payload.selectedObjective,
          },
        };
      } else {
        newState = {
          ...state,
          combinedCampaign: {
            campaign: {
              ...state.combinedCampaign.campaign,
              objective: payload.selectedObjective,
            },
            objective: payload.selectedObjective,
          },
        };
      }

      break;
    case 'UPDATE_CAMPAIGN':
      if (state.combinedCampaign.objective === 'Recover Abandoned Sales') {
        newState = {
          ...state,
          combinedCampaign: {
            ...state.combinedCampaign,
            offsiteCampaign: payload.combinedCampaign.offsiteCampaign,
          },
        };
      } else {
        newState = {
          ...state,
          combinedCampaign: {
            ...state.combinedCampaign,
            campaign: payload.combinedCampaign.campaign,
          },
        };
      }
      break;
    case 'UPDATE_STEP_VALID':
      newState = {
        ...state,
        stepValid: payload.stepValid,
      };
      break;
    case 'UPDATE_VALID_STEPS':
      newState = {
        ...state,
        validSteps: payload.validSteps,
      };
      break;
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }

  return newState;
}
